import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-pure_footer text-pure_footer_txt py-12">
      <div className="max-w-7xl mx-auto px-2 sm:px-3 lg:px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold" style={{ fontFamily: 'The Seasons, serif' }}>
              Colecções
            </h4>
            <div className="space-y-2">
              <a 
                href="/candles" 
                className="block text-pure_footer_txt hover:text-white transition-colors duration-300"
                style={{ fontFamily: 'The Seasons, serif' }}
              >
                Velas
              </a>
              <a 
                href="/wax-melts" 
                className="block text-pure_footer_txt hover:text-white transition-colors duration-300"
                style={{ fontFamily: 'The Seasons, serif' }}
              >
                Wax Melts
              </a>
            </div>
          </div>
          

          {/* Quick Links 2 */}
          <div className="space-y-4">
            <div className="space-y-2">
              <a 
                href="TermoseCondicoes.pdf" 
                target="_blank" 
                className="block text-pure_footer_txt hover:text-white transition-colors duration-300"
                style={{ fontFamily: 'The Seasons, serif' }}
              >
                Termos e Condições
              </a>
              <a 
                href="SobreNos.pdf" 
                target="_blank" 
                className="block text-pure_footer_txt hover:text-white transition-colors duration-300"
                style={{ fontFamily: 'The Seasons, serif' }}
              >
                Sobre Nós
              </a>
            </div>
          </div>
          

          {/* Social & Contact */}
          {/*
          <div className="space-y-4">
            <h4 className="text-lg font-semibold" style={{ fontFamily: 'The Seasons, serif' }}>
              Instagram
            </h4>
            <div className="space-y-2">
              <a 
                href="https://instagram.com/pure.pt_" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-pure_footer_txt hover:text-white transition-colors duration-300"
                style={{ fontFamily: 'The Seasons, serif' }}
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
                <span>@pure.pt_</span>
              </a>
            </div>
          </div>
          */}

          
          <div className="space-y-4">
            <div className="space-y-2">
              <a 
                href="https://instagram.com/pure.pt_" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-pure_footer_txt"
              >
                <svg className="w-11" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>

              <a 
                href="mailto:puressence.candle@gmail.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-pure_footer_txt"
              >
                <svg viewBox="0 0 8 8" className="w-11" fill="currentColor">
                  <path d="m0 0h8v6h-8zm.75 .75v4.5h6.5v-4.5zM0 0l4 3 4-3v1l-4 3-4-3z"/>
                </svg>
              </a>
        
            </div>
          </div>

        </div>
     
        <div className="border-t border-[#A0522D] mt-8 pt-8 text-center">
          <p className="text-pure_footer_txt" style={{ fontFamily: 'The Seasons, serif' }}>
            © 2025 PURE. Feito à mão com Amor, em Portugal
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;